export default {
    props: {
        value: {
            type: Object,
            default: () => ({
                id: null,
            })
        },
        isDisabled: {
            type: Boolean,
            default: false
        },
        options: {
            type: Array,
            default: () => ([])
        },
    },
    data: () => ({
        model: {},
        optionsTree: [],
    }),
    computed: {
        isValidOptionsSelection() {
            return this.optionsTree.reduce((acum, x) => acum || x.selected, false);
        }
    },
    watch: {
        value: {
            deep: true,
            immediate: true,
            handler(newValue) {
                this.model = newValue;
            },
        },
        options: {
            deep: true,
            immediate: true,
            handler(newValue) {
                this.optionsTree = newValue.filter(x => x.impedimentId == this.value.id);
            },
        },
        model: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    }
}